import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/icons/Down.svg'
import _imports_1 from '@/assets/icons/Red.svg'
import _imports_2 from '@/assets/icons/Add.svg'
import _imports_3 from '@/assets/icons/Plus.svg'
import _imports_4 from '@/assets/icons/EditGreen.svg'
import _imports_5 from '@/assets/icons/Qr-code.svg'
import _imports_6 from '@/assets/icons/Edit.svg'
import _imports_7 from '@/assets/icons/SMS.svg'
import _imports_8 from '@/assets/icons/Delete.svg'
import _imports_9 from '@/assets/icons/PickedUpReservation.svg'


const _hoisted_1 = { class: "scroll" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = { class: "thead" }
const _hoisted_4 = { class: "column-main" }
const _hoisted_5 = {
  key: 0,
  class: "column-main-img"
}
const _hoisted_6 = { class: "tbody" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "img-expired",
  src: _imports_1
}
const _hoisted_9 = ["src"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 2,
  class: "tooltiptext"
}
const _hoisted_12 = {
  key: 3,
  class: "img-editShelf",
  src: _imports_4
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick", "data-testid"]
const _hoisted_15 = ["onClick", "data-testid"]
const _hoisted_16 = ["onClick", "data-testid"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick", "data-testid"]
const _hoisted_19 = ["onClick", "data-testid"]
const _hoisted_20 = {
  class: "observer",
  ref: "observer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("thead", _hoisted_3, [
        _createElementVNode("tr", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
            return (_openBlock(), _createElementBlock("th", {
              class: "column-main-title",
              key: column
            }, [
              _createTextVNode(_toDisplayString(column.label) + " ", 1),
              (
                column.value === 'reservedTime' &&
                _ctx.$route.name === 'APIReservations'
              )
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: _normalizeClass({
                'img-down': true,
                'img-rotation': _ctx.changeSort
              }),
                    src: _imports_0,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('sortReservedTime')))
                  }, null, 2))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (
              _ctx.isDeliveryHistory ||
              (_ctx.isUsers && _ctx.user?.role.permissions.user.delete) ||
              _ctx.isReservations
            )
            ? (_openBlock(), _createElementBlock("th", _hoisted_5))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("tbody", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (i, idx) => {
          return (_openBlock(), _createElementBlock("tr", {
            class: "column-content",
            key: i.id
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
              return (_openBlock(), _createElementBlock("td", {
                class: "column-content-title",
                key: column,
                onClick: ($event: any) => (_ctx.selectRow(i, column.value))
              }, [
                (
                column.value === 'deliveryIds' &&
                _ctx.$route.name === 'Reservations' &&
                i.deliveryStatus === 'expired'
              )
                  ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                  : _createCommentVNode("", true),
                (column.value === 'deliveryStatus')
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      src: 
                require(`@/assets/icons/${_ctx.getDeliveryStatus(
                  i[column.value]
                )}.svg`)
              ,
                      alt: "status"
                    }, null, 8, _hoisted_9))
                  : _createCommentVNode("", true),
                _createElementVNode("span", null, _toDisplayString(_ctx.getColumnValue(i, column)), 1),
                (column.value === 'assign')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      class: _normalizeClass({
                'column-content-img': !_ctx.isChooseDelivery,
                tootip: _ctx.isChooseDelivery || _ctx.isAPIReservations
              })
                    }, [
                      ((_ctx.isChooseDelivery && !i.req_ph_ssn) || _ctx.isAPIReservations)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "img",
                            src: _imports_2,
                            alt: "Add",
                            onClick: ($event: any) => (_ctx.$emit('assignDeliveryTable', i[this.selectedField]))
                          }, null, 8, _hoisted_10))
                        : _createCommentVNode("", true),
                      (_ctx.isChooseDelivery && i.req_ph_ssn)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            class: _normalizeClass({ img: true, 'img-plus': i.req_ph_ssn }),
                            src: _imports_3,
                            alt: "Add"
                          }, null, 2))
                        : _createCommentVNode("", true),
                      ((_ctx.isChooseDelivery && !i.req_ph_ssn) || _ctx.isAPIReservations)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('chooseThisDelivery')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.isChooseDelivery && i.req_ph_ssn)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 3,
                            class: _normalizeClass({
                  tooltiptext: true,
                  'tooltiptext-long': _ctx.isChooseDelivery && i.req_ph_ssn
                })
                          }, _toDisplayString(_ctx.$t('onlyShelves')), 3))
                        : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true),
                (
                column.value === 'lockerIdOrShelf' &&
                !i.lockerId &&
                _ctx.pharmacy.shelves &&
                _ctx.isReservations
              )
                  ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_7))
            }), 128)),
            (_ctx.isReservations)
              ? (_openBlock(), _createElementBlock("td", {
                  key: 0,
                  class: "column-content-img",
                  onClick: ($event: any) => (_ctx.$emit('openQRCode', i[this.selectedField]))
                }, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("img", {
                    class: "img",
                    src: _imports_5,
                    alt: "Qr-code"
                  }, null, -1)
                ]))], 8, _hoisted_13))
              : _createCommentVNode("", true),
            (_ctx.isReservations)
              ? (_openBlock(), _createElementBlock("td", {
                  key: 1,
                  class: "column-content-img",
                  onClick: ($event: any) => (_ctx.$emit('addDescription', i[this.selectedField])),
                  "data-testid": 'editDescription' + idx
                }, [...(_cache[2] || (_cache[2] = [
                  _createElementVNode("img", {
                    class: "img",
                    src: _imports_6,
                    alt: "Edit"
                  }, null, -1)
                ]))], 8, _hoisted_14))
              : _createCommentVNode("", true),
            (_ctx.isDeliveryHistory || _ctx.isAlarms)
              ? (_openBlock(), _createElementBlock("td", {
                  key: 2,
                  class: "column-content-img",
                  onClick: ($event: any) => (_ctx.selectField(i)),
                  "data-testid": 'editDescriptionDeliveryHistory' + idx
                }, [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("img", {
                    class: "img",
                    src: _imports_6,
                    alt: "Edit"
                  }, null, -1)
                ]))], 8, _hoisted_15))
              : _createCommentVNode("", true),
            (_ctx.isReservations)
              ? (_openBlock(), _createElementBlock("td", {
                  key: 3,
                  class: _normalizeClass({
              'column-content-img':
                !i.lockerId || i.deliveryStatus === 'delivered',
              'column-content-img-displayNone':
                i.lockerId || i.deliveryStatus !== 'delivered'
            }),
                  onClick: ($event: any) => (_ctx.$emit('resendSMSRequest', i[this.selectedField])),
                  "data-testid": 'resendSMS' + idx
                }, [...(_cache[4] || (_cache[4] = [
                  _createElementVNode("img", {
                    class: "img imgSMS",
                    src: _imports_7,
                    alt: "Resend SMS"
                  }, null, -1)
                ]))], 10, _hoisted_16))
              : _createCommentVNode("", true),
            (_ctx.isAPIReservations)
              ? (_openBlock(), _createElementBlock("td", {
                  key: 4,
                  class: _normalizeClass({
              'column-content-img': true,
              'column-content-img-quickRes': i.req_ph_ssn && _ctx.isAPIReservations
            }),
                  onClick: ($event: any) => (
              !i.req_ph_ssn && _ctx.isAPIReservations
                ? _ctx.$emit('quickReservation', i[this.selectedField])
                : ''
            )
                }, [
                  _createVNode(_component_Button, {
                    class: "quickReservation__button",
                    variant: "bordered",
                    title: _ctx.$t('quickReservation')
                  }, null, 8, ["title"])
                ], 10, _hoisted_17))
              : _createCommentVNode("", true),
            ((_ctx.isReservations && !i.lockerId) || _ctx.isAPIReservations)
              ? (_openBlock(), _createElementBlock("td", {
                  key: 5,
                  class: "column-content-img",
                  onClick: ($event: any) => (_ctx.$emit('deleteReservationTable', i[this.selectedField])),
                  "data-testid": 'deleteReservation' + idx
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("img", {
                    class: "img imgDelete",
                    src: _imports_8,
                    alt: "Delete"
                  }, null, -1)
                ]))], 8, _hoisted_18))
              : _createCommentVNode("", true),
            (_ctx.isReservations || _ctx.isAPIReservations)
              ? (_openBlock(), _createElementBlock("td", {
                  key: 6,
                  class: _normalizeClass({
              'column-content-img':
                (_ctx.isReservations && !i.lockerId) || _ctx.isAPIReservations,
              'column-content-img-displayNone': i.lockerId && !_ctx.isAPIReservations
            }),
                  onClick: ($event: any) => (_ctx.$emit('pickedUpReservation', i[this.selectedField])),
                  "data-testid": 'pickedUpReservation' + idx
                }, [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("img", {
                    class: "img imgReservation",
                    src: _imports_9,
                    alt: "Picked Up Reservation"
                  }, null, -1)
                ]))], 10, _hoisted_19))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_20, null, 512)
  ]))
}